import * as React from "react";
import { SingleNavMenuLinkSpace as ISingleNavMenuLinkSpace } from "../../../pages/identity/useNavMenu";

interface Props {
  link: ISingleNavMenuLinkSpace;
  index: number;
}
export const SingleNavMenuLinkSpace: React.FC<Props> = ({ link, index }) => {
  return (
    <div>
      <div className="my-4" />
    </div>
  );
};
